module.exports = __webpack_public_path__ + "static/media/companies-blue.fb5259e4.svg";